var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-ecwid-store",attrs:{"id":_vm.blockId,"data-qa":"builder-section-onlinestore"}},[(_vm.showStore)?_c('div',{ref:"store",attrs:{"id":("my-store-" + _vm.storeId),"data-qa":"onlinestore-section-ecwid"}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }